import React, { useState } from "react";
import ContactSaisie from "./ContactSaisie";
import ContactConfirmation from "./ContactConfirmation";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const ContactForm = () => {
  const [formData, setFormData] = useState(null); // Stocke les données du formulaire
  const [isConfirmed, setIsConfirmed] = useState(false); // Gère la confirmation

  const handleFormSubmit = (data) => {
    setFormData(data); // Stocke les données saisies
    // alert("setFormData(data)" +data);
    // alert(data);
    console.log(data);
  };

  const handleConfirmation = () => {
    
  setIsConfirmed(true);
  if (window.location.host === "localhost:3000") {
    toast("Environnement local -> Pas d'envoi de mail ... Le mail est bien envoyé");
  } else {
      

    const templateParams = 
    {
      to_name: "Contact ACGVO",
      from_name: formData.user_name,
      from_email: formData.user_email,
      reply_to: formData.user_email,
      message: formData.message,
    };
      
    emailjs
      .send("service_gandiMJ","template_FirstContact",
        templateParams,
        {
          publicKey: 'l_sQyM5FAHQl1hDOq',
        }
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setIsConfirmed(true);
          toast("Votre message a été envoyé avec succès !");
        },
        (error) => {
          console.log('FAILED...', error);
          console.log("FAILED...", error.text);
          setIsConfirmed(false);
          alert("Erreur lors de l'envoi de l'email. Votre message n'a pas été envoyé !");
        }
      );
    }
  };
  


  return (
    <div>
      {!formData ? (
        <ContactSaisie 
          onSubmit={handleFormSubmit} 
         />
      ) : !isConfirmed ? (
        <ContactConfirmation 
          formData={formData} 
          onConfirm={handleConfirmation}
          setFormData={setFormData} // Pass the setFormData function
           />
      ) : (
        <h2 className="text-center py-5 bg-violet-foncee violet-claire">Merci de nous avoir contacté !</h2>
      )}
    </div>
  );
}

export default ContactForm;
